export default {
  home_about: {
    badge: 'Om AllChinaBuy Sheet',
    title: 'Din ultimative\nindkøbsledsager',
    p1: 'AllChinaBuy-spreadsheetet er blevet et uundværligt værktøj for tusindvis af kløgtige shoppere verden over. Uanset om du jager de nyeste sneaker-udgivelser, premium streetwear eller skjulte luksusgems, sparer et velorganiseret spreadsheet dig for timers gennemsøgning.',
    p2: 'Vores AllChinaBuy spreadsheet 2026-katalog samler den mest omfangsrige samling af verificerede fund — fra sko og hoodies til tasker, accessories og meget mere. Hver opføring opdateres regelmæssigt.',
    p3: 'Det, der adskiller vores katalog, er kurationsniveauet. Hver opføring gennemgås manuelt for nøjagtighed og relevans.',
    cta1: 'Besøg hovedbutikken',
    cta2: 'Læs den fulde guide',
  },
  home_trust: {
    badge: 'Hvorfor vælge os',
    title: 'Betroet af tusindvis af shoppere',
    subtitle: 'Vores AllChinaBuy spreadsheet-katalog er bygget på pålidelighed, friskhed og rigtige brugertilbagemeldinger.',
    t1: 'Opdateret ugentligt',
    t1d: 'Vores katalog opdateres hver uge med de nyeste fund, så du aldrig går glip af et nyt drop.',
    t2: 'Kvalitetsverificeret',
    t2d: 'Hvert spreadsheet gennemgår manuel gennemgang før oplistning. Vi tjekker for døde links, forvældede priser og unøjagtige beskrivelser.',
    t3: 'Organiserede kategorier',
    t3d: 'Gennemse 14 omhyggeligt organiserede kategorier — fra sneakers og hoodies til accessories og parfumer — for at finde præcis det, du søger.',
    t4: 'Hurtig navigation',
    t4d: 'Direkte links til verificerede produktoversigter fjerner gætteriet og får dig fra gennemsøgning til køb hurtigere end nogensinde.',
    t5: 'Sammenlignende guides',
    t5d: 'Side om side-sammenligninger hjælper dig med at vurdere forskellige spreadsheet-muligheder, prisniveauer og agentanbefalinger.',
    t6: 'Seneste fund',
    t6d: 'Hold dig først med tidlig adgang til nyopdagede skjulte perler og ukendte tilbud på tværs af alle kategorier.',
  },
  home_articles: {
    badge: 'Seneste guides',
    title: 'Ekspertartikler & Ressourcer',
    subtitle: 'Dyk dybere ned i AllChinaBuy spreadsheets med dybdegående guides, sammenligningsartikler og eksperttips.',
    more: 'Flere guides kommer snart — bogmærk denne side og tjek tilbage ugentligt for nyt indhold.',
  },
  home_faq: {
    badge: 'FAQ',
    title: 'Ofte stillede spørgsmål',
    subtitle: 'Alt hvad du behøver at vide om AllChinaBuy spreadsheets, og hvordan du får mest ud af vores katalog.',
    q1: 'Hvad er et AllChinaBuy spreadsheet?',
    a1: 'Et AllChinaBuy spreadsheet er en kurateret liste over produktlinks organiseret i et regneark, typisk delt inden for rep- og streetwear-fællesskabet. Disse spreadsheets indeholder direkte links til varer tilgængelige via AllChinaBuy-agenten.',
    q2: 'Hvor ofte opdateres spreadsheets?',
    a2: 'Vores katalog opdateres ugentligt. Hvert uge gennemgår vores team nye indlæg, verificerer eksisterende links og tilføjer friske fund på tværs af alle 14 kategorier.',
    q3: 'Hvordan bruger jeg et spreadsheet til at afgive en ordre?',
    a3: 'Gennemse vores katalog og find et produkt. Klik videre til hovedbutikken for at få adgang til det komplette spreadsheet. Kopier linket og indsæt det i AllChinaBuy-agentens søgelinje.',
    q4: 'Er disse spreadsheets gratis at tilgå?',
    a4: 'Ja, alle spreadsheets i vores katalog er helt gratis at tilgå. Du betaler kun for de varer, du vælger at købe, plus standard agentgebyrer og forsendelse.',
    q5: 'Hvordan verificerer I produktkvaliteten?',
    a5: 'Vores verificeringsproces involverer kontrol af sælgervurderinger, gennemgang af fællesskabstilbagemeldinger og QC-fotos. Kun spreadsheets med konsekvent positiv feedback optages i kataloget.',
    q6: 'Kan jeg indsende mit eget spreadsheet?',
    a6: 'Vi byder fællesskabsbidrag velkomne. Hvis du har oprettet et kvalitets-spreadsheet, som du gerne vil dele, kan du kontakte os via hovedbutikkens kontaktside.',
  },
  home_cta: {
    title: 'Klar til at finde din\nnæste store handel?',
    subtitle: 'Bliv en del af tusindvis af smarte shoppere, der allerede bruger vores AllChinaBuy spreadsheet-katalog. Opdateret ugentligt med de nyeste verificerede fund.',
    cta1: 'Gennemse Spreadsheets',
    cta2: 'Læs Guiden',
  },
  home: {
  metaTitle: 'AllChinaBuy Spreadsheet — Find produkter, tjek QC og shop smartere',
  metaDescription:
    'Udforsk AllChinaBuy-spreadsheetet for at finde gode fund, sammenligne kategorier, lære om QC og forstå forsendelsesomkostninger. Uafhængige købsguider samlet ét sted.',
  hero: {
    badge: 'Uafhængig købsguide',
    title: 'AllChinaBuy Spreadsheet — Find produkter, tjek QC og shop smartere',
    subtitle:
      'Udforsk AllChinaBuy-spreadsheetet, find gode fund, sammenlign kategorier, lær om QC, forstå forsendelsesomkostninger og følg praktiske købsguider samlet ét sted.',
  },
  what: {
    title: 'Hvad er AllChinaBuy-spreadsheetet?',
    p1: 'Et AllChinaBuy-spreadsheet er en delbar, organiseret liste over produktfund — links, QC-billeder, sælgernoter og forsendelsestips — der hjælper dig med at gennemse og købe med større tryghed. I stedet for at scrolle gennem endeløse butikssider åbner du én overskuelig tabel og går direkte til varer, der passer til din stil og dit budget.',
    p2: 'Den virkelige værdi ligger i filtreringen. Gode spreadsheets er sorteret efter kategori, markerer om en vare allerede er anmeldt og inkluderer ægte QC-billeder, så du kan springe gætteriet over og undgå almindelige fejl.',
    p1Title: 'Kurateret, ikke tilfældigt',
    p2Title: 'Bygget til at spare dig tid',
  },
  categories: {
    title: 'Gennemse kategorier',
    subtitle: 'Vælg en kategori for at udforske udvalgte produktfund.',
    placeholder: 'Vælg en kategori…',
    go: 'Gå til kategori',
    viewAll: 'Se alle kategorier',
  },
  articles: {
    title: 'Købsguider & Hovedartikler',
    subtitle: 'Uafhængige, originale guides om AllChinaBuy-anmeldelser, forsendelse, QC, kuponer, sikkerhed og mere.',
    readMore: 'Læs artiklen',
  },
  guide: {
    title: 'Seneste spreadsheet-guide',
    subtitle:
      'Ny til spreadsheetet? Start med vores komplette guide om produktfund, QC og smart shopping.',
    cardTitle: 'AllChinaBuy Spreadsheet: Komplet guide',
    cardText:
      'Lær hvordan spreadsheetet virker, hvordan du bruger det trin for trin, og hvad du skal være opmærksom på, før du køber.',
    read: 'Læs guiden',
  },
  faq: {
    title: 'Ofte stillede spørgsmål',
    q1: 'Hvad er et AllChinaBuy-spreadsheet?',
    a1: 'Det er en delbar, organiseret liste over produktfund med links, QC-billeder og noter, der hjælper dig med at gennemse og købe med større tryghed.',
    q2: 'Er dette et officielt AllChinaBuy-website?',
    a2: 'Nej. Dette er en uafhængig informationsressource og er ikke tilknyttet eller godkendt af AllChinaBuy.',
    q3: 'Har jeg brug for spreadsheetet for at handle?',
    a3: 'Nej, men det sparer masser af tid ved at give dig kuraterede links og ægte QC-billeder, som du ellers selv skulle finde.',
    q4: 'Hvor meget koster forsendelse?',
    a4: 'Det afhænger af vægt, størrelse og forsendelseslinje. Lette varer koster mindre, og at samle pakker reducerer som regel totalen.',
  },
  finalCta: {
    title: 'Klar til at finde dit næste produkt?',
    text: 'Gennemse de kuraterede kategorier og start din næste ordre med større tryghed.',
  },
  },
};